mainApp.directive('externalDomain', function () {
	return {
		templateUrl: '/public/directives/externalDomain.html',
		scope: {
			item: '=',
			collapsed: '=',
			testConnectionForDomain: '&',
			deleteOneDomain: '&',
			vpnsyncdisabled: '<'
		},
		controller: ['$scope', 'GeneralUtilsService', '$state', 'IntervalService', function ($scope, GeneralUtilsService, $state, IntervalService) {

			if (isSystemLogin) {
				$scope.isSystemLogin = true;
			}

			$scope.timertimer = null;
			$scope.total = 0;
			$scope.showDomainControllerItem = 'host';
			$scope.loaders = { groups: true };
			$scope.progressReset = false;

			$scope.enablePwChanage = function () {
				$scope.showEditPW = true;
			};

			$scope.enablePwChanage = function () {
				$scope.showEditPW = true;
			};

			$scope.showEditMode = function ($event, type) {
				$event.stopPropagation();

				var $targetEl = $($event.currentTarget);

				var $expandedEl = $targetEl.siblings('.bottom-expanded');
				$expandedEl.clearQueue();
				if ($scope.collapsed) {
					$expandedEl.slideDown(600, function () {
						$scope.collapsed = !$scope.collapsed;
					});
				} else {
					$expandedEl.slideUp(600, function () {
						$scope.collapsed = !$scope.collapsed;
					});
				}
				$targetEl.find('.toggle-btn')
					.toggleClass('open');
			};

			$scope.closeDialog = function(name){
				$scope.$root.closePopup(name);
				IntervalService.cancelDynamicInterval($scope.$id + $scope.groupsProgressId, 'externalDomainProgress');
				resetPopupParams();
			};

			const resetPopupParams = () => {
				$scope.progressId = null;
				$scope.groupsProgressId = null;
				$scope.progress = null;
				$scope.progressReset = false;
			}

			$scope.testDomainLdapConnection = function () {
				$scope.testConnectionForDomain({ domainId: $scope.item.id });
			};

			//Controllers tables config
			$scope.controllersConfigForDomain = {
				dataURL: function () {
					if (!$scope.item.id || $scope.item.id < 0) {
						return null;
					}
					return '/domainControllers?domainId=' + $scope.item.id;
				},
				items: [],
				showTable: false,
				fields: [
					{
						label: 'Host',
						path: 'host',
						template: '<span>{{item.host ? (item.host + \':\' + item.port) : (item.siteName + \':\' + item.subnet.name)}}</span>'
					},
				],
				type: 'DomainController',
				actions: [],
				selectedItems: [],
				pageSize: 10,
				specialActions: [
					{
						func: function (item) {
							if (!$scope.item.domainControllers) {
								$scope.item.domainControllers = [];
							}
							$scope.newDomainController = {};
							$scope.$root.openPopup('addDomainControllers-' + $scope.item.id);
							$scope.controllersConfigForDomain.selectedItems = [];
							$scope.controllersConfigForDomain.items.forEach(function (item) {
								if (item.subnet) {
									$scope.subnetsConfig.selectedItems.push(item.subnet);
								}
							});
						},
						icon: 'add',
						tooltip: 'New',
					},
					{
						func: function (selectedItems) {
							var deletedItems = [];

							selectedItems.forEach(function (item) {
								for (var i = 0; i < $scope.controllersConfigForDomain.items.length; i++) {
									var controller = $scope.controllersConfigForDomain.items[i];
									if (controller.id == item.id) {
										$scope.controllersConfigForDomain.items.splice(i, 1);
										deletedItems.push(controller);
										break;
									}
								}
							});
							GeneralUtilsService.addItemsToDelete($scope.item, deletedItems, 'domainControllers');

						},
						icon: 'delete',
						tooltip: 'Delete',
					},
				],
				noSearch: true
			};

			// subnect table for Domain controllers popup - allows multi select
			$scope.subnetsConfig = {
				titleSearch: true,
				dataURL: function () {
					return '/subnets?accountId=' + $state.params.accountId;
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
					{
						label: 'Site',
						name: 'siteName',
						template: '<span>{{item.siteName}}</span>'
					},
					{
						label: 'Network',
						path: 'interfaceName',
						template: '<span>{{item.interfaceName}} <span ng-if=\'item.range\'> \\ {{item.range}}</span></span>'
					},
					{
						label: 'IP',
						path: 'subnet',
						template: '<span>{{item.translatedSubnet}}</span>'
					}
				],
				type: 'Subnet',
				actions: [],
				selectedItems: [],
				pageSize: 5,
			};

			$scope.wmiSourceConfigForDomain = {
				dataURL: function () {
					if (!$scope.item.id || $scope.item.id < 0) {
						return null;
					}
					return '/wmiSource?domainId=' + $scope.item.id;
				},
				showTable: false,
				fields: [
					{
						label: 'Host',
						path: 'host',
						template: '<span>{{item.host?(item.host):(item.siteName + \':\' + item.subnet.name)}}</span>'
					},
					{
						label: 'Username',
						path: 'username',
						template: '<span><input type=\'text\' class=\'form-control\' ng-model=\'item.username\' /></span>'
					},
					{
						label: 'Password',
						path: 'pw',
						template: '<div ng-click=\'tableConfig.enablePwChanage(item)\' ng-show=\'item.showEditPW != true\' ng-scope>Change Password &nbsp;<span class=\'glyphicon glyphicon-lock\'></span></div><input ng-show=\'item.showEditPW == true\' type=\'password\' class=\'form-control\' ng-model=\'item.pw\'  autocomplete=\'New-password\'/>',
						'noSort': true
					},
					{
						label: 'DC Connection Status',
						path: 'test',
						template: '<button ng-show=\'item.id>0\' type=\'submit\' class=\'btn btn-save cato-btn btn-sm\' ng-click=\'tableConfig.testWmiConnection(item)\'>Show Status</button>',
						'noSort': true
					},
				],
				//		showEditPW: [],
				enablePwChanage: function (item) {
					item.showEditPW = true;
				},
				testWmiConnection: function (item) {
					$scope.testWmiConnection(item);
				},
				type: 'domainController',
				actions: [],
				selectedItems: [],
				pageSize: 10,
				specialActions: [
					{
						func: function (selectedItems) {
							$scope.newDomainController = {};
							$scope.$root.openPopup('addWmiSourceForDomainDlg-' + $scope.item.id);
							$scope.subnetsConfig.selectedItems = [];
							$scope.wmiSourceConfigForDomain.items.forEach(function (item) {
								if (item.subnet) {
									$scope.subnetsConfig.selectedItems.push(item.subnet);
								}
							});
						},
						icon: 'add',
						tooltip: $scope.item.id > 0 ? 'New' : 'Save the above configuration before adding a Domain Controller for Real-Time Sync',
					},
					{
						func: function (selectedItems) {
							selectedItems.forEach(function (item) {
								for (var i = 0; i < $scope.wmiSourceConfigForDomain.items.length; i++) {
									var controller = $scope.wmiSourceConfigForDomain.items[i];
									if (controller.id == item.id) {
										var deletedControllers = $scope.wmiSourceConfigForDomain.items.splice(i, 1);
										if (!$scope.item.itemsToDelete) {
											$scope.item.itemsToDelete = {};
										}
										if (!$scope.item.itemsToDelete.wmiDomainControllers) {
											$scope.item.itemsToDelete.wmiDomainControllers = [];
										}
										$scope.item.itemsToDelete.wmiDomainControllers = $scope.item.itemsToDelete.wmiDomainControllers.concat(deletedControllers);
										break;
									}
								}
							});
						},
						icon: 'delete',
						tooltip: 'Delete',
					},
				],
				id: 'wmiDomainControllers',
				noSearch: true,
				actionsDisabled: !$scope.item.id || $scope.item.id < 0
			};

			//subnets table for WMI controllers popup - allows to select only one host each time
			$scope.subnetsConfigSingleSelect = {
				titleSearch: true,
				multiSelect: false,
				hideCheckboxes: true,
				actions: false,
				dataURL: function () {
					return '/subnets?f=1&accountId=' + $state.params.accountId;
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
					{
						label: 'Site',
						name: 'siteName',
						template: '<span>{{item.siteName}}</span>'
					},
					{
						label: 'Network',
						path: 'interfaceName',
						template: '<span>{{item.interfaceName}} <span ng-if=\'item.range\'> \\ {{item.range}}</span></span>'
					},
					{
						label: 'IP',
						path: 'subnet',
						template: '<span>{{item.subnet}}</span>'
					}
				],
				type: 'Subnet',
				selectedItems: [],
				pageSize: 5,
				onSelect: function (index, item) {
				},
			};

			$scope.addDomainControllersForDomain = function () {
				// remove de-selected items
				removeUnselectedDomainControllers();

				// add newly selected items
				addSelectedDomainControllers();

				$scope.$root.closePopup('addDomainControllers-' + $scope.item.id);
			};

			$scope.addWmiSourceForDomain = function () {
				var newDc = $scope.showDomainControllerItem === 'host' ? {
						id: GeneralUtilsService.getRandomId(),
						domainId: $scope.item.id,
						subnet: $scope.subnetsConfigSingleSelect.selectedItems[0],
						showEditPW: true,
						username: $scope.newDomainController.username,
						pw: $scope.newDomainController.pw
					} :
					{
						id: GeneralUtilsService.getRandomId(),
						domainId: $scope.item.id,
						host: $scope.newDomainController.host,
						showEditPW: true,
						username: $scope.newDomainController.username,
						pw: $scope.newDomainController.pw
					};
				var params = {
					'accountId': $state.params.accountId,
					'domainId': $scope.item.id,
					'type': 'WmiDomainController',
					'save': true
				};
				$scope.loadingSaveNew = true;
				store.save({
					path: '/add',
					data: newDc,
					dataObj: 'json',
					queryParams: params,
					success: function (data) {
						$scope.loadingSaveNew = false;
						$scope.$root.handleServerResponse(data, 'newDC', 'Domain Controller added successfully');
						if (data.status !== 'ERROR') {
							$scope.wmicontrollersdatamodified = new Date().getTime();
							$scope.$root.closePopup('addWmiSourceForDomainDlg-' + $scope.item.id);
						}
					}
				});
			};

			$scope.testWmiConnection = function (item) {
				store.fetch({
					path: '/testWmiConnection',
					queryParams: { dcId: item.id },
					success: function (data) {
						$scope.progressId = data.id;
						$scope.progress = data;
						$scope.viewProgress = true;
						$scope.progressReset = new Date().getTime();
						$scope.$digest();
					},
				});
				$scope.$root.openPopup('syncDLg-' + $scope.item.id);
			};

			//import result tables config
			$scope.addedUsersConfig = {
				titleSearch: 'Added Users',
				dataURL: function () {
					return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=CREATED&entityType=ACCESSLOGIN';
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
					{
						label: 'E-mail',
						path: 'email',
						template: '<span>{{item.email}}</span>'
					},
				],
				type: '',
				sortField: 'id',
				hideCheckboxes: true,
			};

			$scope.removedUsersConfig = {
				titleSearch: 'Deleted Users',
				dataURL: function () {
					return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=DELETED&entityType=ACCESSLOGIN';
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
					{
						label: 'E-mail',
						path: 'email',
						template: '<span>{{item.email}}</span>'
					},
				],
				type: '',
				sortField: 'id',
				hideCheckboxes: true,
			};


			$scope.disabledUsersConfig = {
				titleSearch: 'Disabled Users',
				dataURL: function () {
					return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=DISABLED&entityType=ACCESSLOGIN';
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
					{
						label: 'E-mail',
						path: 'email',
						template: '<span>{{item.email}}</span>'
					},
				],
				type: '',
				sortField: 'id',
				hideCheckboxes: true,
			};

			$scope.modifiedUsersConfig = {
				titleSearch: 'Modified Users',
				dataURL: function () {
					return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=MODIFIED&entityType=ACCESSLOGIN';
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
					{
						label: 'E-mail',
						path: 'email',
						template: '<span>{{item.email}}</span>'
					},
				],
				type: '',
				sortField: 'id',
				hideCheckboxes: true,
			};

			$scope.enabledUsersConfig = {
				titleSearch: 'Enabled Users',
				dataURL: function () {
					return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=ENABLED&entityType=ACCESSLOGIN';
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
					{
						label: 'E-mail',
						path: 'email',
						template: '<span>{{item.email}}</span>'
					},
				],
				type: '',
				sortField: 'id',
				hideCheckboxes: true,
			};

			$scope.addedGroupsConfig = {
				titleSearch: 'Added Groups',
				dataURL: function () {
					return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=CREATED&entityType=GROUP';
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
				],
				type: '',
				sortField: 'id',
				hideCheckboxes: true,
			};

			$scope.removedGroupsConfig = {
				titleSearch: 'Removed Groups',
				dataURL: function () {
					return '/viewLDAPRecords?accountId=' + $state.params.accountId + '&progressId=' + $scope.progressId + '&changeType=DELETED&entityType=GROUP';
				},
				showTable: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					}
				],
				type: '',
				sortField: 'id',
				hideCheckboxes: true,
			};


			$scope.openSyncSingleDlg = function () {
				if ($scope.$root.hasChanges()) {
					if (confirm('You have unsaved changes.Do you want to save them first?')) {
						$scope.saveLDAP(doOpenSync);
					} else {
						doOpenSync();
					}
				} else {
					if (!$scope.item.groupFilter) {
						$scope.$root.confirm('You haven\'t selected groups to import. Cato will now synchronize the entire directory. Do you want to continue?', function () {
							doOpenSync();
						});
					} else {
						doOpenSync();
					}
				}
			};

			$scope.openChooseGroupDlg = function (from) {
				$scope.groupFilterSource = from;
				if ($scope.item.id) {
					store.fetch({
						path: '/queryGroups',
						queryParams: { domainId: $scope.item.id },
						success: (data) => {
							$scope.groupsProgressId = data.id;
							IntervalService.dynamicInterval(updateProgress, $scope.$id + $scope.groupsProgressId, 'externalDomainProgress', true);
						}
					});
					$scope.$root.openPopup('chooseGroupsDLg-' + $scope.item.id);
					$scope.loaders.groups = true;
					$scope.selectGroups = true;
				}
			};

			let updateProgress = () => {
				store.fetch({
					path: '/progress',
					queryParams: { id: $scope.groupsProgressId },
					success: (data) => {
						if (data.progress == 100 || data.status === 'ERROR') {
							IntervalService.cancelDynamicInterval($scope.$id + $scope.groupsProgressId, 'externalDomainProgress');
						}
						// start showing groups after passing the 10%  mark
						if (data.progress > 10) {
							$scope.groupsModified = true;
							var groupDnSplittingRegex = /[^##]+(\##[^##]+)?/g;
							if ($scope.groupFilterSource == 'UA') {
								$scope.allGroupsConfigSingleDomain.selectedItems = [];
								if ($scope.item.groupUaFilter) {
									var groupNames = $scope.item.groupUaFilter.split(',');
									var groupDns = $scope.item.groupUaDNFilter.match(groupDnSplittingRegex);
									for (let i = 0; i < groupNames.length; i++) {
										$scope.allGroupsConfigSingleDomain.selectedItems.push({
											name: groupNames[i],
											dn: groupDns[i],
											id: groupDns[i] + groupNames[i]
										});
									}
								}
							} else {
								$scope.allGroupsConfigSingleDomain.selectedItems = [];
								if ($scope.item.groupFilter) {
									var groupNames = $scope.item.groupFilter.split(',');
									var groupDns = $scope.item.groupDNFilter.match(groupDnSplittingRegex);
									for (let i = 0; i < groupNames.length; i++) {
										$scope.allGroupsConfigSingleDomain.selectedItems.push({
											name: groupNames[i],
											dn: groupDns[i],
											id: groupDns[i] + groupNames[i]
										});

									}
								}
							}
							$scope.loaders.groups = false;
						} else if (data.status === 'ERROR') {
							$scope.$root.handleServerResponse(data, 'newDomain', '');
							$scope.$root.closePopup('chooseGroupsDLg-' + $scope.item.id);
						}
					},
				});
			}

			$scope.deleteDomain = function () {
				$scope.$root.confirm('Are you sure you want to delete ' + $scope.item.name + ' domain?', function () {
					$scope.deleteOneDomain({ domainId: $scope.item.id });
				});
			};

			$scope.allGroupsConfigSingleDomain = {
				dataURL: function () {
					return '/viewGroups?domainId=' + $scope.item.id + '&progressId=' + $scope.groupsProgressId;
				},
				continuous: true,
				keepPageOnRefresh: true,
				showTable: false,
				showLoader: false,
				fields: [
					{
						label: 'Name',
						path: 'name',
						template: '<span>{{item.name}}</span>'
					},
				],
				processData: function (items, data) {
					$scope.total = data ? data.total : 0;
					items.forEach(function (item) {
						item.id = item.dn + item.name;
					});
					return items;
				},
				type: '',
				titleSearch: 'Groups',
				success: $scope.loaders.groups = true,
				actions: [],
			};

			// Setting primitive values to null isnt marked as change on backend, so setting to empty string
			$scope.clearFilter = function (from) {
				if (from === 'VPN') {
					$scope.item.groupFilter = '';
					$scope.item.groupDNFilter = '';
				} else {
					$scope.item.groupUaFilter = '';
					$scope.item.groupUaDNFilter = '';
				}
			};

			$scope.chooseGroups = function () {
				if ($scope.groupFilterSource == 'UA') {
					$scope.item.groupUaFilter = '';
					$scope.item.groupUaDNFilter = '';
					$scope.allGroupsConfigSingleDomain.selectedItems.forEach(function (group) {
						$scope.item.groupUaFilter += (group.name + ',');
						$scope.item.groupUaDNFilter += (group.dn + '##');
					});
					if ($scope.item.groupUaFilter) {
						$scope.item.groupUaFilter = $scope.item.groupUaFilter.substring(0, $scope.item.groupUaFilter.length - 1);
						$scope.item.groupUaDNFilter = $scope.item.groupUaDNFilter.substring(0, $scope.item.groupUaDNFilter.length - 2);
					}
				} else {
					$scope.item.groupFilter = '';
					$scope.item.groupDNFilter = '';
					$scope.allGroupsConfigSingleDomain.selectedItems.forEach(function (group) {
						$scope.item.groupFilter += (group.name + ',');
						$scope.item.groupDNFilter += (group.dn + '##');
					});
					if ($scope.item.groupFilter) {
						$scope.item.groupFilter = $scope.item.groupFilter.substring(0, $scope.item.groupFilter.length - 1);
						$scope.item.groupDNFilter = $scope.item.groupDNFilter.substring(0, $scope.item.groupDNFilter.length - 2);
					}
				}
				$scope.$root.closePopup('chooseGroupsDLg-' + $scope.item.id);
				$scope.selectGroups = null;
			};


			$scope.$on('$destroy', function () {
				IntervalService.cancelDynamicInterval($scope.$id + $scope.groupsProgressId, 'externalDomainProgress');
			});

			//ctrl functions
			function removeUnselectedDomainControllers() {
				var controllerTableItems = angular.copy($scope.controllersConfigForDomain.items);
				var unselectedItems = [];

				// remove un-selected items from table
				for (var i = controllerTableItems.length - 1; i >= 0; i--) {
					var controller = controllerTableItems[i];
					if (controller.subnet) {
						if (!itemExists($scope.subnetsConfig.selectedItems, controller.subnet)) {
							$scope.controllersConfigForDomain.items.splice(i, 1);
							if (controller.id > 0) {
								unselectedItems.push(controller);
							}
						}
					}
				}
				//add un selected items to items to delete
				GeneralUtilsService.addItemsToDelete($scope.item, unselectedItems, 'domainControllers');
			}

			function addSelectedDomainControllers() {
				$scope.subnetsConfig.selectedItems.forEach(function (subnet) {
					if (!subnetExistsInDCs(subnet)) {
						var newDC = {
							id: GeneralUtilsService.getRandomId(),
							subnet: subnet,
							siteName: subnet.siteName
						};
						$scope.controllersConfigForDomain.items.push(newDC);
						$scope.item.domainControllers.push(newDC);
					}
				});

				if ($scope.newDomainController.host) {
					var newDC = {
						id: GeneralUtilsService.getRandomId(),
						host: $scope.newDomainController.host,
						port: $scope.newDomainController.port
					};
					$scope.controllersConfigForDomain.items.push(newDC);
					$scope.item.domainControllers.push(newDC);
				}
			}

			function itemExists(collection, item) {
				var exists = false;

				collection.forEach(function (i) {
					exists = exists || angular.equals(i, item);
				});

				return exists;
			}

			function subnetExistsInDCs(subnet) {
				var foundSubnet = false;
				$scope.controllersConfigForDomain.items.forEach(function (controller) {
					if (angular.equals(controller.subnet, subnet)) {
						foundSubnet = true;
					}
				});

				return foundSubnet;
			}

			function doOpenSync() {
				store.fetch({
					path: '/syncDomain',
					queryParams: { domainId: $scope.item.id },
					success: function (data) {
						$scope.progressId = data.id;
						$scope.progress = data;
						$scope.viewProgress = true;
						$scope.progressReset = new Date().getTime();
					},
				});
				$scope.$root.openPopup('syncDLg-' + $scope.item.id);
			}

			$scope.$on('$reset-popup-params', ()  => {
				resetPopupParams();
			});

		}]
	};
});
